import { gql } from "@apollo/client"
import { TRAINING_COURSE_FIELDS, TRAINING_COURSES_FIELDS } from "./courseFragments"
import { TRAINING_MODULE_FIELDS } from "./moduleFragments"
import { KNOWLEDGE_CONTENT_FIELDS } from "./knowledgeContentFragment"
import { TRAINING_MODULE_STEP_FIELDS } from "./moduleStepFragment"

export const USER_TRAINING_STEP_ANSWER_FIELDS = gql`
  fragment UserTrainingStepAnswerFields on UserTrainingStepAnswer {
    step {
      id
      name
      type
    }
    answer
    isCorrect
  }
`

export const USER_TRAINING_STEP_FIELDS = gql`
  fragment UserTrainingStepFields on UserTrainingStep {
    step {
      id
      name
      type
      content
      knowledgeContent {
        ... on KnowledgeTrainingModule {
          ...KnowledgeContentFields
        }
      }
      selections {
        id
        value
      }
      scormUpload {
        id
        fileName
        key
      }
    }
    answers {
      ...UserTrainingStepAnswerFields
    }
    completedAt
  }
  ${USER_TRAINING_STEP_ANSWER_FIELDS}
  ${KNOWLEDGE_CONTENT_FIELDS}
`

export const USER_TRAINING_STATUS_SCORE_FIELDS = gql`
  fragment UserTrainingStatusScoreFields on UserTrainingStatusScore {
    correct
    incorrect
    total
    percent
  }
`

export const USER_TRAINING_MODULE_STATUS_FIELDS = gql`
  fragment UserTrainingModuleStatusFields on UserTrainingModuleStatus {
    module {
      ...TrainingModuleFields
    }
    steps {
      ...UserTrainingStepFields
    }
    completedAt
    score {
      ...UserTrainingStatusScoreFields
    }
  }
  ${TRAINING_MODULE_FIELDS}
  ${USER_TRAINING_STEP_FIELDS}
  ${USER_TRAINING_STATUS_SCORE_FIELDS}
`

export const USER_TRAINING_COURSE_DETAIL_FIELDS = gql`
  fragment UserTrainingCourseDetailFields on UserTrainingCourseDetail {
    id
    course {
      ...TrainingCourseFields
    }
    user {
      id
      fullName
      avatar {
        key
      }
      activeAt
    }
    status {
      completedAt
      hasPassed
      modules {
        module {
          id
          name
          description
          steps {
            ...TrainingModuleStepFields
          }
          banner {
            id
            key
            fileName
            fileGroup
            fileSize
          }
          type
        }
        responses {
          step {
            ...TrainingModuleStepFields
          }
          answers
          answerText
          matchUpAnswers {
            value
            phrase
          }
          isCorrect
          completedAt
          hasConfirmed
          scormData
        }
        completedAt
        score {
          correct
          incorrect
          total
          percent
        }
        skipped
      }
      percentComplete
      score {
        correct
        incorrect
        total
        percent
      }
    }
  }
  ${TRAINING_COURSE_FIELDS}
  ${TRAINING_MODULE_STEP_FIELDS}
`

export const USER_TRAINING_COURSE_LIST_FIELDS = gql`
  fragment UserTrainingCourseListFields on UserTrainingCourse {
    id
    dueAt
    course {
      ...TrainingCoursesFields
    }
    status {
      completedAt
      percentComplete
      hasPassed
      score {
        correct
        incorrect
        total
        percent
      }
      activeModule
      modules {
        module {
          id
          name
          description
          steps {
            ...TrainingModuleStepFields
          }
        }
        completedAt
        score {
          correct
          incorrect
          total
          percent
        }
      }
    }
  }
  ${TRAINING_COURSES_FIELDS}
  ${TRAINING_MODULE_STEP_FIELDS}
`

export const USER_TRAINING_COURSE_RESPONSE_FIELDS = gql`
  fragment UserTrainingCourseResponseFields on UserTrainingCourseDetail {
    id
    course {
      ...TrainingCourseFields
    }
    status {
      completedAt
      hasPassed
      modules {
        responses {
          answers
          answerText
          matchUpAnswers {
            value
            phrase
          }
          completedAt
          hasConfirmed
          scormData
        }
      }
    }
    retakeUserTraining
  }
  ${TRAINING_COURSE_FIELDS}
`
